import { objectEntries, objectFromEntries } from "@nens/shared-utils";

import { ObjectSchema } from "../types/object-schema";

const isOutputDestination = (format?: string) =>
  format === "rana_file" || format === "rana_directory";

/** Keep only output fields for which the user must choose a destination. */
/* So files and directories, and 'anyOf' fields that include a file or directory. */
export const filterOutputSchemaForForm = (outputSchema: ObjectSchema): ObjectSchema => {
  const properties = objectFromEntries(
    objectEntries(outputSchema.properties).filter(([, value]) => {
      if (!value || typeof value === "boolean") return false;

      return (
        isOutputDestination(value.format) ||
        value.anyOf?.some((variant) => {
          return typeof variant !== "boolean" && isOutputDestination(variant.format);
        })
      );
    })
  );

  return {
    ...outputSchema,
    properties,
    // Also update required so that it doesn't contain fields we don't show.
    required: outputSchema.required?.filter((key) => key in properties),
  };
};
